import { Box, Card, Container, Flex, Heading } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import env from 'config';
import { RADIX } from 'lib_ts/enums/radix-ui';
import React from 'react';
import { ReactNode } from 'react-markdown/lib/react-markdown';
import useMiscStore from 'stores/use-misc-store';

interface IProps {
  header: string;
  children: ReactNode;
}

interface IState {}

export class LandingFormWrapper extends React.Component<IProps, IState> {
  timeoutRedirect: any;

  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <ErrorBoundary identifier="LandingFormWrapper">
        <Container
          className="wrapper"
          size="1"
          style={{
            marginTop: '30vh',
          }}
        >
          <Card size="3">
            <Flex direction="column" gap={RADIX.FLEX.GAP.MD} align="center">
              <img
                alt="Trajekt logo"
                title={env.getBuildStamp()}
                src={useMiscStore.getState().getThemeImgPath('logo.svg')}
                className="select-none"
                style={{
                  width: '50%',
                  maxWidth: '320px',
                  height: 'auto',
                }}
              />

              <Heading size={RADIX.HEADING.SIZE.SM}>
                {this.props.header}
              </Heading>

              <Box width="100%">{this.props.children}</Box>
            </Flex>
          </Card>
        </Container>
      </ErrorBoundary>
    );
  }
}
